import { render, staticRenderFns } from "./SelectLight.vue?vue&type=template&id=142e6b0e&"
import script from "./SelectLight.vue?vue&type=script&lang=js&"
export * from "./SelectLight.vue?vue&type=script&lang=js&"
import style0 from "./SelectLight.vue?vue&type=style&index=0&id=142e6b0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports